import React, { useMemo } from 'react';
import { CustomSelect } from '../../../shared/components/custom';
import { useComptabiliteFiscalYearOptions } from '../utils/useComptabiliteFiscalYearOptions';
import { fiscalYearSelectOptionsWithFallback } from '../utils/fiscalYearUtils';

/** Live fiscal year picker — refreshes when Clôture / Exercice config changes. */
export default function ComptabiliteFiscalYearField({
  value,
  onChange,
  label,
  placeholder,
  required = false,
  labelClassName = 'block w-full text-white/70 text-sm mb-2 font-medium text-right',
}) {
  const fiscalYearOptions = useComptabiliteFiscalYearOptions();
  const options = useMemo(
    () => fiscalYearSelectOptionsWithFallback(fiscalYearOptions, value),
    [fiscalYearOptions, value],
  );

  return (
    <div>
      <label className={labelClassName}>
        {label}
        {required ? <span className="qawaem-required-mark">*</span> : null}
      </label>
      <CustomSelect
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        searchable
        autoSelect={false}
      />
    </div>
  );
}
